import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.css']
})

export class ColorPickerComponent {
  selected: Array<string> = [];
  public hue: string;
  public color: string;
  hex: string;

  @Output()
  backgroundColor: EventEmitter<string> = new EventEmitter();

  rgbToHex(rgb: any) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" +
      ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
      ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
      ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
  }

  userSelect(clr: string) {
    if (this.selected.length > 4) {
      this.selected.reverse();
      this.selected.pop();
      this.selected.reverse();
    }
    this.selected.push(this.rgbToHex(clr));
    this.hex = this.rgbToHex(clr);
  }

  selectColor(color) {
    this.backgroundColor.emit(color);
  }

}
